var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"moreContent",staticClass:"hidden"},[_vm._t("default")],2),_vm._v(" "),(!_vm.showingMore)?_vm._t("more-link",null,{"moreLinkEvents":_vm.moreLinkEvents}):_vm._e()],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4abc5720","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/MoreContent.vue
// module id = 81
// module chunks = 2